import {DataSource} from '@angular/cdk/collections';

import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MatSelect, MatSort, Sort} from '@angular/material';
import {Router} from '@angular/router';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ToastrService} from 'ngx-toastr';
import {BehaviorSubject, merge, Observable, Subscription} from 'rxjs';
import {tap} from 'rxjs/operators';
import {SCREEN_SIZE} from 'src/app/core/constants/screen-size';
import {CommonService} from 'src/app/core/services/common.service';
import {DigitalCertificateService} from 'src/app/core/services/digital-certificate.service';
import {NotificationService} from 'src/app/core/services/notification.service';
import {ResponsiveService} from 'src/app/core/services/responsive.service';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {EnumSignMethod} from "../../../../../../core/constants/contract";
import {ViewDigitalCertificateComponent} from "../../digital-certificate/view-digital-certificate/view-digital-certificate.component";
import {BreadcrumbsService} from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import {Message} from "../../../../../../core/class/message";
import {ErrorCode} from "../../../../../../core/constants/error-code";

@Component({
  selector: 'app-digital-certificate-default',
  templateUrl: './digital-certificate-default.component.html',
  styleUrls: ['./digital-certificate-default.component.scss']
})
export class DigitalCertificateDefaultComponent implements OnInit, AfterViewInit, OnDestroy {
  displayedColumns: string[] = [];

  columnDefinitions = [
    {def: "stt", showXS: true, showSM: true, showMD: true},
    {def: "cloudCaProviderName", showXS: false, showSM: true, showMD: false},
    {def: "typeCertificate", showXS: true, showSM: true, showMD: true},
    {def: "issuedTo", showXS: false, showSM: true, showMD: true},
    {def: "serialNumber", showXS: false, showSM: true, showMD: false},
    {def: "taxCode", showXS: false, showSM: true, showMD: false},
    {def: "phoneNumber", showXS: false, showSM: true, showMD: false},
    {def: "activeDate", showXS: false, showSM: true, showMD: false},
    {def: "expireDate", showXS: false, showSM: true, showMD: false},
    {def: "status", showXS: true, showSM: true, showMD: true},
    {def: "isSync", showXS: false, showSM: true, showMD: false},
    {def: "hasTransSaved", showXS: false, showSM: true, showMD: false},
    {def: "action", showXS: true, showSM: true, showMD: true},
    {def: "detail", showXS: true, showSM: true, showMD: true},
  ];

  dataSource: DigitalCertificateDataSource;

  digitalCertificate = new DigitalCertificate();
  paginate: Paginate;
  oldData = this.digitalCertificate;
  isFirstLoad = true;
  sortDirection = 'ASC';
  sortColumn = 'name';
  error = '';
  userType: any;
  checkFocus = false;
  // enterpriseId: string;
  enumSignMethod = EnumSignMethod;

  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild('typeCertificateSelect', {static: false}) typeCertificateSelect: MatSelect;

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  listDigitalCertificate: any;

  constructor(
    private digitalCertificateService: DigitalCertificateService,
    public commonService: CommonService,
    private notificationService: NotificationService,
    private router: Router,
    private responsiveService: ResponsiveService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    public message: Message,
    public deviceService: DeviceDetectorService,
    public breadcrumbsService: BreadcrumbsService
  ) {
    this.paginate = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: []
    };
    this.userType = localStorage.getItem('userType');
  }

  ngOnInit() {
    // load data for first time
    this.loadDataForFirstTime();
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);
    this.breadcrumbs()

  }
  breadcrumbs(){
    this.breadcrumbsService.store([
      {label: 'breadcrumbs.home', url: 'analysis-report', params: [], highlight: false },
      {label: 'breadcrumbs.user_config_breadcrumbs', url: '', params: [], highlight: false },
      {label: 'breadcrumbs.digital_certificate', url: '', params: [], highlight: false }
    ]);
  }

  ngAfterViewInit(page: number = 0) {
    // setTimeout(_ => document.getElementById('focusSelect').focus());
    // register event for for sorting

    merge(this.sort.sortChange, page)
      .pipe(
        tap(() => this.onFilterData(this.paginate.currentPage, this.paginate.pageSize))
      )
      .subscribe();

    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
          this.getDisplayedColumns();
        }
      }
    );
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMD)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
      }
    }
  }

  ngOnDestroy(): void {
    // this.notificationService.unsubscribeErrorService();
    // this.subscribeMediaBreakPointService.unsubscribe();
  }

  loadDataForFirstTime(page: number = 0, pageSize: number = 10) {
    this.dataSource = new DigitalCertificateDataSource();

    this.getSortDirection();
    this.digitalCertificateService.searchDigitalCertificateDefault(
      this.getFilterCondition(page, pageSize))
      .subscribe(response => {
        if (this.responseHaveData(response)) {
          this.initPaginateToDisplay(response);
        }
        if (response.data && response.data.dataRow != null) {
          this.initDataToDisplay(response);

        }
      }, err => {
      });
  }

  responseHaveData(response: any): boolean {
    return response.data != null &&
      response.data.currentPage != null &&
      response.data.pageSize != null &&
      response.data.totalRow != null
  }


  /**
   * Filter data with condition
   */
  onFilterData(page: number = 0, pageSize: number = 10) {
    this.getSortDirection();
    this.digitalCertificateService.searchDigitalCertificateDefault(
      this.getFilterCondition(page, pageSize))
      .subscribe(
        response => {
          this.initPaginateToDisplay(response);
          this.initDataToDisplay(response);
        }
      );
  }

  getSortDirection() {
    if (this.isFirstLoad === false) {
      if (this.sort.direction === 'asc') {
        this.sortDirection = 'ASC';
      } else if (this.sort.direction === 'desc') {
        this.sortDirection = 'DESC';
      }
    } else {
      this.isFirstLoad = false;
    }
  }

  initPaginateToDisplay(rs: any) {
    this.paginate = {
      currentPage: rs.data.currentPage,
      pageSize: rs.data.pageSize,
      totalRow: rs.data.totalRow,
      totalPage: Math.ceil(rs.data.totalRow / rs.data.pageSize),
      totalPageArray: this.counter(Math.ceil(rs.data.totalRow / rs.data.pageSize), 1),
      no: this.counter(rs.data.pageSize, rs.data.currentPage * rs.data.pageSize + 1)
    };
  }

  initDataToDisplay(response: any): void {
    let stt = this.paginate.pageSize * this.paginate.currentPage + 1;

    response.data.dataRow.forEach(parent => {
      parent['STT'] = stt++;
    });
    this.listDigitalCertificate = response.data.dataRow;
    this.dataSource.setData(response.data.dataRow);
  }

  getFilterCondition(
    page: number, pageSize: number,
    typeCertificateContain: any = null, enterpriseIdContain: any = null
  ): any {

    let filterCondition = {};

    filterCondition = {
      id: 0,
      typeCertificate: typeCertificateContain,
      enterpriseId: enterpriseIdContain == null || enterpriseIdContain === '' ? localStorage.getItem('enterpriseId') : enterpriseIdContain,
      page,
      pageSize,
    };

    let sortColumn = null;
    let sortDirection = null;

    sortDirection = this.sortDirection;
    sortColumn = this.sortColumn; // is searching in parent

    let column = null;

    switch (sortColumn) {

      case 'taxCode':
        column = {
          taxCode: sortDirection
        };
        break;
      case 'phoneNumber':
        column = {
          phoneNumber: sortDirection
        };
        break;
      case 'typeCertificate':
        column = {
          typeCertificate: sortDirection
        };
        break;
      case 'effectiveDate':
        column = {
          effectiveDate: sortDirection
        };
        break;
      case 'activeDate':
        column = {
          activeDate: sortDirection
        };
        break;
      case 'expireDate':
        column = {
          expireDate: sortDirection
        };
        break;
    }

    filterCondition['sorts'] = column;

    return filterCondition;
  }

  /**
   * Count record to show
   */
  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  sortData(sort: Sort) {

    if (!sort.active || sort.direction === '') {
      return;
    }
    this.sortColumn = sort.active;
  }

  /**
   * Filter data when close dialog
   */
  onFilterDataAfterClose() {
    if (this.paginate.totalRow % this.paginate.pageSize === 1) {
      if (this.paginate.currentPage - 1 < 0) {
        this.paginate.currentPage = 0;
      } else {
        this.paginate.currentPage = this.paginate.currentPage - 1;
      }
    }
    this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
  }

  /**
   * Navigate to page register OTP
   */
  registerOTP() {
    this.router.navigate(['/home-enterprise/otp-register/'], {
      queryParams: {
        page: this.paginate.currentPage,
        pageSize: this.paginate.pageSize,
      }
    });
  }

  viewDigitalCertificateDetail(id, idDetail, typeCertificate) {
    const dialogRe = this.dialog.open(ViewDigitalCertificateComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : (typeCertificate === 3 ? '50%' : '60%'),
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '85vw',
      panelClass: 'scontract-overlay-dialog',
      data: {id, idDetail, typeCertificate}
    });
    dialogRe.afterClosed().subscribe(res =>{
      if(res && res.isReload){
        this.onFilterData(this.paginate.currentPage, this.paginate.pageSize);
      }
    })
  }

  changDefaultStatus(element: any) {
    const data = {
      digitalCertificateId: element.id,
      isSetDefault: !element.defaultCertificate,
      ...element
    };
    this.digitalCertificateService.changeDefaultStatus(data).subscribe(rs => {
      if (rs && rs.success) {
        this.toastr.success(this.message.getMessage('messages.update_status_success'));
        this.onFilterData()
      }

      if(rs && !rs.success){
        this.toastr.error(rs.message);
        this.onFilterData()
      }
    })
  }
}

export class DigitalCertificate {
  id: string;
  idDetail: string;
  enterpriseId: string;
  enterpriseName: string;
  serialNumber: string;
  taxCode: string;
  activeDate: string;
  expireDate: string;
  isDeleted: boolean;
  typeCertificate: any = 'null';
  phoneNumber: string;
  filePath: string;
  issuedTo: string;

  // int ACTIVE = 0
  // int PENDING = 1
  // int EXPIRED = 2
  certificateStatus: number;
  defaultCertificate: boolean;
}

export class DigitalCertificateDataSource extends DataSource<DigitalCertificate> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<DigitalCertificate[]>([]);

  constructor() {
    super();
  }


  setData(data: DigitalCertificate[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<DigitalCertificate[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }
}

export class Paginate {
  currentPage: number;
  pageSize: number;
  totalRow: number;
  totalPage: number;
  totalPageArray: [];
  no: [];
}

